import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { regexInternalLink } from "../constants/regex";
import { defaultLanguage } from "../constants/languages";

const Link = ({
  children,
  to,
  activeClassName,
  className,
  style,
  ...otherProps
}) => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const isInternal = regexInternalLink.test(to);

  let modifiedTo = to;
  if (isInternal) {
    modifiedTo = language === defaultLanguage ? to : `/${language}${to}`;
  }

  return isInternal ? (
    <GatsbyLink
      to={modifiedTo}
      activeClassName={activeClassName}
      className={className}
      style={style}
      {...otherProps}>
      {children}
    </GatsbyLink>
  ) : (
    <a href={modifiedTo} className={className} style={style} {...otherProps}>
      {children}
    </a>
  );
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  activeClassName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

Link.defaultProps = {
  activeClassName: "",
  className: "",
  style: {},
};

export default Link;
